var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchFeature(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.002,
    height: 20.012,
    viewBox: "0 0 20.002 20.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search_feature",
    "data-name": "search feature",
    d: "M82.734,13.679l1.5,1.529h0a1.53,1.53,0,0,0,.326,1.682l2.89,2.89a1.529,1.529,0,1,0,2.161-2.161l-2.89-2.89a1.529,1.529,0,0,0-1.794-.27l-1.463-1.483a7.649,7.649,0,1,0-.729.719Zm6.158,5.368a.517.517,0,0,1-.724,0l-2.89-2.89a.536.536,0,0,1-.148-.362A.51.51,0,0,1,86,15.432l2.89,2.89a.517.517,0,0,1,0,.724ZM77.739,1.266a6.627,6.627,0,1,1-4.686,1.941,6.627,6.627,0,0,1,4.686-1.941Zm0,1.02A5.607,5.607,0,1,0,81.7,3.928a5.607,5.607,0,0,0-3.965-1.642Zm0,1.02a4.588,4.588,0,1,1-3.244,1.344,4.588,4.588,0,0,1,3.244-1.344Zm-.51,6.117h3.059a.51.51,0,0,0,0-1.02H77.229a.51.51,0,1,0,0,1.02ZM75.19,7.383h5.1a.51.51,0,1,0,0-1.02h-5.1a.51.51,0,0,0,0,1.02Z",
    transform: "translate(-70.095 -0.256)",
    fill: "#bebfb6",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFeature);
export default __webpack_public_path__ + "static/media/search-feature.b0fe9726c81cfb487ff38df120f27f30.svg";
export { ForwardRef as ReactComponent };